// SimilarCompanies
export const similarCompanies = state => state.similarCompanies;
export const similarCompaniesPage = state => state.similarCompaniesPage;
export const similarCompaniesError = state => state.similarCompaniesError;
export const similarCompaniesLoading = state => state.similarCompaniesLoading;
export const isViewMoreVisible = state => state.isViewMoreVisible;
